import computed from '../use-inputs/computed';
import { cloneDeep } from 'lodash';

const omit = (obj, ...props) => {
  const result = { ...obj };
  props.forEach((prop) => {
    delete result[prop];
  });
  return result;
};

const omitChargers = (chargingWindows) => {
  const newChargingWindows = cloneDeep(chargingWindows);

  for (let i = 0; i < newChargingWindows.length; i++) {
    newChargingWindows[i] = omit(newChargingWindows[i], 'charger');
  }
  return newChargingWindows;
};

//Remove the computed vehicle/charger data out of the vehicles obj before saving to state
export const omitComputedData = (sites) => {
  const newSites = cloneDeep(sites);
  for (let i = 0; i < newSites.length; i++) {
    const newSets = cloneDeep(sites[i].vehicleSets);

    for (let j = 0; j < newSets.length; j++) {
      newSets[j] = omit(newSets[j], 'archetype', 'fossilVehicle', 'vehicle');
      newSets[j].chargingWindows = omitChargers(newSets[j].chargingWindows);
    }
    newSites[i].vehicleSets = cloneDeep(newSets);
  }
  return newSites;
};

// Add computed vehicle/charger data so 'working' state (not directly from use-inputs) can access the full state
export const addComputedData = (inputs) => {
  const computedParams = Object.keys(computed)
    .filter((key) => inputs.hasOwnProperty(key))
    .reduce((acc, key) => {
      return { ...acc, [key]: computed[key]({ ...inputs }) };
    }, {});

  return { ...inputs, ...computedParams };
};
